import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import PerText from '../../../../components/custom_components/Text'
import PerIcon from '../../../../components/custom_components/Icon'
import PerFlexRow from '../../../../components/custom_components/FlexRow'
import { Col } from 'antd'

type Props = {
  subtitle: string
  info: string
}

export const AppraisalWelcomeTeaser: FC<Props> = ({ subtitle, info }) => {
  const [t] = useTranslation()

  return (
    <>
      <PerFlexRow direction="row">
        <Col span={10}>
          <PerText appearance="title" color="primary">
            {t('appraisalMeeting.stepOverview.pageDescriptionTitle')}
          </PerText>
          <PerText appearance="subtitle" color="secondary">
            {subtitle}
          </PerText>
        </Col>
        <Col span={8}>
          <PerText appearance="info" mt="xxs">
            {info}
          </PerText>
        </Col>
        <Col span={6} style={{ textAlign: 'right' }}>
          <PerIcon name="meeting_stroke" size={150} variant="decoration" color="secondary" />
        </Col>
      </PerFlexRow>
    </>
  )
}
